<template>
  <div :class="classObject">
    <InputfieldLabel
      :class="labelClass"
      :text="label"
      :for="fieldId"
    />
    <InputfieldDescription
      :text="description"
    >
      <slot name="description" />
    </InputfieldDescription>
    <div class="field__content">
      <select
        ref="input"
        class="field__input field__input--select"
        v-bind="[$attrs, $listeners]"
        :id="fieldId"
        :name="name"
        :value="value"
        @change.prevent="onInput"
      >
        <slot />
      </select>
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes" />
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldLabel from '@/components/forms/InputfieldLabel'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'

export default {
  name: 'InputfieldSelect',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldLabel,
    InputfieldDescription,
    InputfieldNotes,
  },
  props: {
    type: {
      type: String,
      required: false,
      default () {
        return 'text'
      },
    },
    labelClass: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
  },
  methods: {
    onInput (e) {
      this.clearErrors()
      this.$emit('input', e.target.value)
    },
    focus () {
      this.$refs.input.focus()
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
